import { fetcher } from '@commenda/utils';

export default async function deleteFileFolder(
  fileFolderId: string
): Promise<Response> {
  const res = await fetcher(`fileFolder/${fileFolderId}`, {
    method: 'DELETE',
  });
  return res;
}
